import React, { Component } from "react";
import CSSClasses from "./TicketPreview.css";
import { GetConvertedOdds } from "../../HOCs/Helpers/OddConverter";
import Auxx from "../../HOCs/AUXX/Auxx";
import {
  SubmitComboTicket,
  SubmitSystemTicket,
  MakeTicketLosing,
  MakeTicketWinning,
  AuthorizeTicket
} from "../../Communication/TicketServicesHandler";
import { UpdateSessionBalance } from "../../Communication/OtherServicesHandler";
import * as Preferences from "../../Communication/Preferences";
import * as ZebraErrorCodes from "../../HOCs/Constants/ZebraErrorCodes";
import * as LocalStorageKeys from "../../HOCs/Constants/LocalStorageKeys";
import SystemCombinationsPopup from "../../Components/SystemCombinationsPopup/SystemCombinationsPopup";

import RegularKeyboard, {
  KEYBOARD_POSITION_FOR_USERNAME_PASSWORD
} from "../Keyboards/RegularKeyboard/RegularKeyboard";
import NumericKeyboard from "../Keyboards/NumericKeyboard/NumericKeyboard";

import FullscreenModalPopup from "../../Components/UI/FullscreenModalPopup/FullscreenModalPopup";

import { connect } from "react-redux";
import * as StoreActions from "../../ReduxStore/Actions/ActionIndex";

import SiteIcons from "../../assets/fonts/site_icons/style.css";
import imgLogo from "../../assets/images/wwin_logo_black.png";
//import imgPrinter from "../../assets/images/img_printer.png";
import gifPrinter from "../../assets/images/printer_anim.gif";

import beepMedium from "../../assets/sounds/beep_medium.mp3";

let moment = require("moment");
require("moment/locale/hr.js");
require("moment/locale/de.js");
require("moment/locale/bs.js");
require("moment/locale/sr.js");
require("moment/locale/sl.js");

class TicketPreview extends Component {
  K_TEXTBOX_USERNAME = 1;
  K_TEXTBOX_PASSWORD = 2;
  K_TEXTBOX_AMOUNT = 3;

  state = {
    isSubmitInProgress: false,
    isSubmitSuccess: false,
    isSubmitError: false,
    shouldConfirmBet: false,
    didConfirmBet: false,
    isPrintingTicket: false,
    isTicketPrinted: false,
    newTicketInfo: null,
    ticketStatusID: 0, //0 uplata 1 prihvacen 7 dobitni 8 gubitni 4 autoriziran(cekajuci)
    isInPayout: false,
    isInTransferToSaldo: false,
    isInTransferToWWin: false,
    showsRegularKeyboard: false,
    showsNumbericKeyboard: false,
    txtUsernameValue: "",
    txtPasswordCharValue: "",
    txtAmountPayoutValue: 0,
    currentTextboxID: 0,
    isTransferToSaldoCompleted: false,
    isPayoutActionsPaused: false,
    isPayoutInProgress: false,
    isPayoutCompleted: false,
    totalDispendedAmount: 0,
    infoMessage: null,
    authorizationStatus: 0, //0 nista 1 zaprimljen 2 odbijen 3 modificiran i vracen 4 autoriziran
    lastSentTicketPayload: {}
  };

  componentDidMount() {
    window.addEventListener(
      "onReportMaxPayout",
      function(e) {
        this.checkMaxPayout_Callback(e.detail.amount);
      }.bind(this)
    );

    window.addEventListener(
      "onReportDispendedBill",
      function(e) {
        this.reportDispendedBill_Callback(e.detail.amount);
      }.bind(this)
    );
  }

  reportDispendedBill_Callback = amount => {
    //ako trenutno nisi prikazan, return, nije za tebe!
    if (!(this.props.currentTicketNumber > 1)) {
      return;
    }

    var totalPaidOut = this.state.totalDispendedAmount + amount;

    this.setState({
      totalDispendedAmount: totalPaidOut
    });

    if (totalPaidOut === this.state.txtAmountPayoutValue) {
      //prenesi na saldo visak
      this.props.addToBalance(
        (this.props.ticketData.generalInfo.WinAmount -
          this.state.txtAmountPayoutValue) *
          100
      );

      this.setState({
        isPayoutInProgress: false,
        isPayoutCompleted: true,
        isPayoutActionsPaused: false
      });
    }
  };

  checkMaxPayout_Callback = amount => {
    //ako trenutno nisi prikazan, return, nije za tebe!
    if (!(this.props.currentTicketNumber > 1)) {
      return;
    }

    if (amount !== this.state.txtAmountPayoutValue) {
      //alert("Kladomat moze isplatiti najvise " + amount + " BAM!");
      var msg = (
        <p>
          Kladomat može isplatiti najviše {amount} BAM!
          <br />
          <br />
          Zatražena isplata: {this.state.txtAmountPayoutValue} BAM
        </p>
      );

      this.setState({ infoMessage: msg });

      //ne moze sve sto je trazio, promijeni
      this.setState({ txtAmountPayoutValue: amount });
      return;
    }

    //proslo, znaci pokreni isplatu
    this.setState({ isPayoutInProgress: true, isPayoutActionsPaused: true });

    //pokreni paree
    window.cefCustomObject.payoutBillAmount(this.state.txtAmountPayoutValue);
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    //vidi ako je u propsima da je isprintan tiket

    if (prevProps.currentLanguage !== this.props.currentLanguage) {
      moment.locale(this.props.currentLanguage);
      console.log("CHANGED LANG!");
    }

    if (
      !this.state.isTicketPrinted &&
      this.props.printerStatusList.includes(
        ZebraErrorCodes.ZEBRA_WARNING_AT_SENSOR_PRESENTER
      ) &&
      this.props.printerStatusList.includes(
        ZebraErrorCodes.ZEBRA_WARNING_AT_SENSOR_RETRACT_READY
      ) &&
      this.props.printerStatusList.includes(
        ZebraErrorCodes.ZEBRA_WARNING_AT_SENSOR_IN_RETRACT
      )
    ) {
      //postavi state da je isprintan!
      this.setState({
        isTicketPrinted: true,
        isSubmitSuccess: false,
        isSubmitInProgress: false
      });
    }

    if (
      this.state.isTicketPrinted &&
      !this.props.printerStatusList.includes(
        ZebraErrorCodes.ZEBRA_WARNING_AT_SENSOR_PRESENTER
      )
    ) {
      //bio u presenteru a vise nije, zatvori tiket!
      this.closeTheTicket();
    }
  }

  getMaxPayoutForTicket = () => {
    if (this.props.currentTicketTypeID === 2) {
      return this.props.betAmount * this.props.totalOdds;
    } else {
      //izracunaj iz combs
      let maxWin = 0;

      this.props.systemCombinations.forEach(system => {
        if (system.isChecked) {
          system.combinationList.forEach(comb => {
            maxWin += comb.possibleWin;
          });
        }
      });

      return maxWin;
    }
  };

  getTotalBetForTicket = () => {
    if (this.props.currentTicketTypeID === 2) {
      return this.props.betAmount;
    } else {
      //izracunaj iz combs
      let betAmount = 0;

      this.props.systemCombinations.forEach(system => {
        if (system.isChecked) {
          betAmount += system.betTotal;
        }
      });

      return betAmount;
    }
  };

  render() {
    if (this.props.currentTicketNumber < 1) {
      //cao
      return null;
    }

    //1 je izrada tiketa, sve iznad je existing tiket
    let isExistingTicket = this.props.currentTicketNumber > 1;

    if (isExistingTicket && !this.props.ticketData) {
      this.setState({
        infoMessage:
          "Nedostaju podaci o postojećem tiketu! " +
          this.props.currentTicketNumber
      });
      return null;
    }

    //console.log("PAIRS ", this.props.ticketPairInfo);

    var tmpDate = new Date();

    return (
      <div className={CSSClasses.container}>
        <audio
          ref={sound => {
            this.beepMedium = sound;
          }}
        >
          <source src={beepMedium} type="audio/mpeg" />
        </audio>

        {/* pisi i popup ako ima */}
        {this.props.currentTicketTypeID === 3 ? (
          <SystemCombinationsPopup />
        ) : null}

        <FullscreenModalPopup
          message={this.state.infoMessage}
          btnOkClickCallback={this.modalPopupBtnOk_Callback}
        />

        <div
          className={[
            CSSClasses.combinedBox,
            this.props.currentTicketTypeID === 3
              ? CSSClasses.offsetForSystem
              : ""
          ].join(" ")}
        >
          <div className={CSSClasses.ticketBox}>
            <div className={CSSClasses.header}>
              <div className={CSSClasses.logoBox}>
                <img src={imgLogo} alt="" />
              </div>
              {this.props.currentTicketNumber > 1 ? (
                <div style={{ float: "left", marginLeft: "50px" }}>
                  <button
                    onClick={() => {
                      //pozovi da napravis dobitni tiket
                      MakeTicketWinning(
                        this.props.currentTicketNumber,
                        function() {
                          this.setState({
                            infoMessage:
                              "Radnja uspjela, ponovno skenirajte tiket."
                          });
                        }.bind(this)
                      );
                    }}
                  >
                    WIN
                  </button>
                  <button
                    onClick={() => {
                      //pozivi da napravis gubitni tiket
                      MakeTicketLosing(
                        this.props.currentTicketNumber,
                        function() {
                          this.setState({
                            infoMessage:
                              "Radnja uspjela, ponovno skenirajte tiket."
                          });
                        }.bind(this)
                      );
                    }}
                    style={{ marginLeft: "50px" }}
                  >
                    LOSE
                  </button>
                </div>
              ) : null}

              {/* {isExistingTicket ? (
                <div
                  className={CSSClasses.closeBtn}
                  onClick={() => {
                    console.log("TAP");
                    //this.props.closeEvent();
                    this.props.setTicketNumberForDetails(-1);
                  }}
                >
                  <span
                    className={[
                      SiteIcons.site_icon_close_thin
                      //,CssClasses.fadingAnim
                    ].join(" ")}
                  />
                </div>
              ) : (
                ""
              )} */}

              {isExistingTicket ? (
                <div className={CSSClasses.ticketInfo}>
                  <div className={CSSClasses.leftPart}>VRIJEME UPLATE:</div>
                  <div className={CSSClasses.rightPart}>
                    {moment(this.props.ticketData.generalInfo.TimestampAccepted)
                      .add(-tmpDate.getTimezoneOffset(), "m")
                      .format("DD.MM.YYYY. HH:mm:ss")}
                  </div>
                  <div className={CSSClasses.leftPart}>BROJ LISTIĆA:</div>
                  <div className={CSSClasses.rightPart}>
                    {this.getFormattedTicketNumber(
                      this.props.ticketData.generalInfo.TicketNumber
                    )}
                  </div>
                  <div className={CSSClasses.leftPart}>ZAŠTITNI KOD:</div>
                  <div className={CSSClasses.rightPart}>
                    {this.getFormattedTicketNumber(
                      this.props.ticketData.generalInfo.TicketCode
                    )}
                  </div>
                </div>
              ) : null}

              {this.state.newTicketInfo ? (
                <div className={CSSClasses.ticketInfo}>
                  <div className={CSSClasses.leftPart}>VRIJEME UPLATE</div>
                  <div className={CSSClasses.rightPart}>
                    {moment(this.state.newTicketInfo.TimestampAccepted).format(
                      "DD.MM.YYYY. HH:mm:ss"
                    )}
                  </div>
                  <div className={CSSClasses.leftPart}>BROJ LISTIĆA:</div>
                  <div className={CSSClasses.rightPart}>
                    {this.getFormattedTicketNumber(
                      this.state.newTicketInfo.TicketNumber
                    )}
                  </div>
                  <div className={CSSClasses.leftPart}>ZAŠTITNI KOD:</div>
                  <div className={CSSClasses.rightPart}>
                    {this.getFormattedTicketNumber(
                      this.state.newTicketInfo.TicketCode
                    )}
                  </div>
                </div>
              ) : null}

              <div className={CSSClasses.clearFix} />
            </div>

            <div className={CSSClasses.clearFix} />

            <div className={CSSClasses.captionRow}>
              <div className={CSSClasses.legendBox}>
                <div
                  className={[
                    CSSClasses.boxTitlePair,
                    isExistingTicket
                      ? ""
                      : CSSClasses.boxTitlePairForBuildTicket
                  ].join(" ")}
                >
                  Naziv
                </div>
                <div
                  className={[
                    CSSClasses.boxTitleOdds,
                    isExistingTicket
                      ? ""
                      : CSSClasses.boxTitleOddsForBuildTicket
                  ].join(" ")}
                >
                  Kvota
                </div>

                {isExistingTicket ? (
                  <div className={CSSClasses.boxTitleResult}>Rezultat</div>
                ) : null}
              </div>
              <div className={CSSClasses.legendBox}>
                <div
                  className={[
                    CSSClasses.boxTitlePair,
                    isExistingTicket
                      ? ""
                      : CSSClasses.boxTitlePairForBuildTicket
                  ].join(" ")}
                >
                  Naziv
                </div>
                <div
                  className={[
                    CSSClasses.boxTitleOdds,
                    isExistingTicket
                      ? ""
                      : CSSClasses.boxTitleOddsForBuildTicket
                  ].join(" ")}
                >
                  Kvota
                </div>

                {isExistingTicket ? (
                  <div className={CSSClasses.boxTitleResult}>Rezultat</div>
                ) : null}
              </div>
            </div>

            {isExistingTicket
              ? this.getExistingTicketPairsMarkup(
                  this.props.ticketData.generalInfo.IsSystem
                )
              : this.getCreatingTicketPairsMarkup()}

            <div className={CSSClasses.clearFix} />

            <div className={CSSClasses.footerRow}>
              <div className={CSSClasses.summaryBox}>
                UPLATA:
                <span className={CSSClasses.value}>
                  {isExistingTicket
                    ? this.props.ticketData.generalInfo.TotalBet.toFixed(2)
                    : (this.getTotalBetForTicket() * 0.01).toFixed(2)}
                  {this.props.machineInfo.CurrencyCode}
                </span>
              </div>
              <div className={CSSClasses.summaryBox}>
                POREZ:
                <span className={CSSClasses.value}>
                  {isExistingTicket
                    ? this.props.ticketData.generalInfo.TaxAmount.toFixed(2)
                    : (0).toFixed(2)}
                  {this.props.machineInfo.CurrencyCode}
                </span>
              </div>
              <div className={CSSClasses.summaryBox}>
                ULOG:
                <span className={CSSClasses.value}>
                  {isExistingTicket
                    ? this.props.ticketData.generalInfo.TotalBet.toFixed(2)
                    : (this.getTotalBetForTicket() * 0.01).toFixed(2)}
                  {this.props.machineInfo.CurrencyCode}
                </span>
              </div>

              {this.props.currentTicketTypeID === 2 ? (
                <div className={CSSClasses.summaryBox}>
                  KOEF.:
                  <span className={CSSClasses.value}>
                    {isExistingTicket
                      ? this.props.ticketData.generalInfo.IsSystem
                        ? 0
                        : this.props.ticketData.generalInfo.Odds.toFixed(2)
                      : GetConvertedOdds(
                          this.props.currentOddFormat,
                          this.props.totalOdds
                        )}
                  </span>
                </div>
              ) : null}

              <div className={CSSClasses.summaryBox}>
                DOBITAK:
                <span className={CSSClasses.value}>
                  {isExistingTicket
                    ? this.props.ticketData.generalInfo.WinAmount.toFixed(2)
                    : (this.getMaxPayoutForTicket() * 0.01).toFixed(2)}
                  {this.props.machineInfo.CurrencyCode}
                </span>
              </div>
              <div
                className={[CSSClasses.summaryBox, CSSClasses.larger].join(" ")}
              >
                EV. ISPLATA:
                <span className={CSSClasses.value}>
                  {isExistingTicket
                    ? this.props.ticketData.generalInfo.WinAmount.toFixed(2)
                    : (this.getMaxPayoutForTicket() * 0.01).toFixed(2)}
                  {this.props.machineInfo.CurrencyCode}
                </span>
              </div>

              <div className={CSSClasses.clearFix} />
            </div>
          </div>

          <div className={CSSClasses.buttonsBox}>
            {/* {!this.props.isExistingTicket ? (
              <div
                className={[
                  CSSClasses.closeBtn,
                  CSSClasses.closeBtnForBuildTicket
                ].join(" ")}
                onClick={() => {
                  console.log("TAP");
                  //this.props.closeEvent();
                  this.props.setTicketNumberForDetails(-1);
                }}
              >
                <span
                  className={[
                    SiteIcons.site_icon_close_thin
                    //,CssClasses.fadingAnim
                  ].join(" ")}
                />
              </div>
            ) : (
              ""
            )} */}

            {isExistingTicket ? null : (
              <div className={CSSClasses.infoBox}>
                {this.state.isTicketPrinted ? (
                  <Auxx>
                    {" "}
                    <span>Listić je uspješno ispisan!</span>
                    <br />
                    <span>Preuzmite listić</span>
                  </Auxx>
                ) : this.state.isPrintingTicket ? (
                  "Ispisujem listić..."
                ) : this.state.isSubmitSuccess ? (
                  <Auxx>
                    <span>Listić je uspješno prihvaćen!</span>
                  </Auxx>
                ) : this.state.isSubmitError ? (
                  this.state.authorizationStatus === 2 ? (
                    "Odbijeno na autorizaciji!"
                  ) : this.state.authorizationStatus === 3 ? (
                    "Vraćeno s autorizacije"
                  ) : (
                    "Došlo je do greške prilikom prihvata listića!"
                  )
                ) : this.state.isSubmitInProgress ? (
                  this.state.authorizationStatus === 0 ? (
                    "Uplata tiketa u tijeku..."
                  ) : this.state.authorizationStatus === 1 ? (
                    "Čekanje na autorizaciju..."
                  ) : this.state.authorizationStatus === 4 ? (
                    "Listić je autoriziran!"
                  ) : (
                    "Nepoznat status autorizacije: " +
                    this.state.authorizationStatus
                  )
                ) : this.state.shouldConfirmBet ? (
                  "Na listiću se nalaze neaktivni parovi! Želite li nastaviti s uplatom preostalih parova?"
                ) : (
                  "Provjerite odabir i potvrdite uplatu tiketa"
                )}

                <br />
                <br />
                <br />

                {this.state.isSubmitSuccess ? (
                  <div
                    className={[
                      CSSClasses.circleLoader,
                      CSSClasses.loadComplete
                    ].join(" ")}
                  >
                    <div
                      className={[
                        CSSClasses.checkmark,
                        CSSClasses.draw,
                        CSSClasses.blockElement
                      ].join(" ")}
                    />
                  </div>
                ) : this.state.isSubmitError ? (
                  <div
                    className={[
                      CSSClasses.circleLoader,
                      CSSClasses.loadComplete,
                      CSSClasses.loadError
                    ].join(" ")}
                  >
                    <div className={[CSSClasses.errorContainer].join(" ")}>
                      <span className={[CSSClasses.spinningX].join(" ")}>
                        X
                      </span>
                    </div>
                  </div>
                ) : this.state.isSubmitInProgress ? (
                  <div className={[CSSClasses.circleLoader].join(" ")}>
                    <div
                      className={[CSSClasses.checkmark, CSSClasses.draw].join(
                        " "
                      )}
                    />
                  </div>
                ) : this.state.isTicketPrinted ? (
                  <img
                    src={gifPrinter}
                    alt=""
                    className={CSSClasses.printerImg}
                  />
                ) : (
                  <div className={CSSClasses.loader3}>Loading...</div>
                )}
              </div>
            )}

            {!isExistingTicket ? null : (
              <div
                className={[
                  CSSClasses.infoBox,
                  this.props.ticketData.generalInfo.TicketStatusID === 7
                    ? CSSClasses.boxForWinningTicket
                    : this.props.ticketData.generalInfo.TicketStatusID === 8
                    ? CSSClasses.boxForLosingTicket
                    : CSSClasses.boxForPendingTicket
                ].join(" ")}
              >
                {this.props.ticketData.generalInfo.TicketStatusID === 7
                  ? this.state.isPayoutCompleted
                    ? "Listić je isplaćen!"
                    : "Listić je dobitan!"
                  : this.props.ticketData.generalInfo.TicketStatusID === 8
                  ? "Listić je gubitni!"
                  : this.props.ticketData.generalInfo.TicketStatusID === 1 ||
                    this.props.ticketData.generalInfo.TicketStatusID === 4
                  ? "Listić je u tijeku!"
                  : "Nepoznat status: " +
                    this.props.ticketData.generalInfo.TicketStatusID}
                <br />
                <hr className={CSSClasses.titleSeparator} />

                {this.state.isInPayout &&
                !this.state.isPayoutInProgress &&
                !this.state.isPayoutCompleted ? (
                  <div className={CSSClasses.instructions}>
                    Dobitak listića:{" "}
                    {this.props.ticketData.generalInfo.RemainingWin.toFixed(2) +
                      this.props.machineInfo.CurrencyCode}
                    <br />
                    <br />
                    Unesite iznos koji želite isplatiti:
                    <input
                      type="text"
                      className={[
                        CSSClasses.txtBetAmount,
                        this.state.currentTextboxID === this.K_TEXTBOX_AMOUNT
                          ? CSSClasses.txtActive
                          : ""
                      ].join(" ")}
                      value={this.state.txtAmountPayoutValue}
                      onClick={() => {
                        this.txtNumeric_Enter(this.K_TEXTBOX_AMOUNT);
                      }}
                      onSelect={ev => {
                        ev.target.selectionStart = ev.target.selectionEnd;
                      }}
                    />
                    <br />
                    <span className={CSSClasses.remark}>
                      Napomena: Kladomat može isplatiti samo okrugle iznose!
                    </span>
                    <br />
                    <br />
                    Ostatak će biti prebačen na saldo.
                    <br />
                    Novac sa salda možete koristiti za igru ili ispisati potvrdu
                    za isplatu u poslovnici ili na drugom kladomatu.
                  </div>
                ) : this.state.isInTransferToSaldo ? (
                  <div className={CSSClasses.instructions}>
                    Dobitak listića:{" "}
                    {this.props.ticketData.generalInfo.RemainingWin.toFixed(2) +
                      this.props.machineInfo.CurrencyCode}
                    <br />
                    <br />
                    {this.state.isTransferToSaldoCompleted ? (
                      <div>
                        <br />
                        Novac je uspješno prenesen na saldo!
                      </div>
                    ) : (
                      <div>
                        Vaš dobitak će biti prenesen na saldo kladomata.
                        <br />
                        Novac sa salda možete koristiti za igru ili ispisati
                        potvrdu za isplatu u poslovnici ili na drugom kladomatu.
                      </div>
                    )}
                  </div>
                ) : this.state.isInTransferToWWin ? (
                  <div className={CSSClasses.instructions}>
                    Dobitak listića:{" "}
                    {this.props.ticketData.generalInfo.RemainingWin.toFixed(2) +
                      this.props.machineInfo.CurrencyCode}
                    <br />
                    <br />
                    Unesite korisničko ime i četvrti znak lozinke kako biste
                    prenijeli novac na WWin račun.
                    <br />
                    <br />
                    Korisničko ime
                    <input
                      type="text"
                      className={[
                        CSSClasses.txtBetAmount,
                        this.state.currentTextboxID === this.K_TEXTBOX_USERNAME
                          ? CSSClasses.txtActive
                          : ""
                      ].join(" ")}
                      value={this.state.txtUsernameValue}
                      onClick={() => {
                        this.txtRegular_Enter(this.K_TEXTBOX_USERNAME);
                      }}
                      onSelect={ev => {
                        ev.target.selectionStart = ev.target.selectionEnd;
                      }}
                    />
                    <br />
                    Četvrti znak lozinke
                    <input
                      type="password"
                      className={[
                        CSSClasses.txtBetAmount,
                        this.state.currentTextboxID === this.K_TEXTBOX_PASSWORD
                          ? CSSClasses.txtActive
                          : ""
                      ].join(" ")}
                      value={this.state.txtPasswordCharValue}
                      onChange={this.txtAmount_Change}
                      onClick={() => {
                        this.txtRegular_Enter(this.K_TEXTBOX_PASSWORD);
                      }}
                      onSelect={ev => {
                        ev.target.selectionStart = ev.target.selectionEnd;
                      }}
                    />
                    <br />
                  </div>
                ) : this.state.isPayoutInProgress ? (
                  <div className={CSSClasses.instructions}>
                    U tijeku je isplata iznosa:{" "}
                    {this.state.txtAmountPayoutValue.toFixed(2) +
                      this.props.machineInfo.CurrencyCode}
                    <br />
                    <br />
                    Dosad isplaćeno:
                    <br />
                    <div className={CSSClasses.payoutCounter}>
                      {this.state.totalDispendedAmount}/
                      {this.state.txtAmountPayoutValue}
                      {this.props.machineInfo.CurrencyCode}
                    </div>
                  </div>
                ) : this.state.isPayoutCompleted ? (
                  <div className={CSSClasses.instructions}>
                    Dobitak listića:{" "}
                    {this.props.ticketData.generalInfo.WinAmount.toFixed(2) +
                      this.props.machineInfo.CurrencyCode}
                    <br />
                    <br />
                    Isplaćeno u gotovini:{" "}
                    {this.state.txtAmountPayoutValue.toFixed(2) +
                      this.props.machineInfo.CurrencyCode}
                    <br />
                    <br />
                    Preneseno na saldo:{" "}
                    {(
                      this.props.ticketData.generalInfo.WinAmount -
                      this.state.totalDispendedAmount
                    ).toFixed(2)}
                    {this.props.machineInfo.CurrencyCode}
                    <br />
                    <br />
                  </div>
                ) : (
                  <div className={CSSClasses.instructions}>
                    Dobitak listića:{" "}
                    {this.props.ticketData.generalInfo.RemainingWin.toFixed(2) +
                      this.props.machineInfo.CurrencyCode}
                    <br />
                    <br />
                    Odaberite što želite učitini s dobitkom.
                  </div>
                )}
              </div>
            )}

            {this.state.isTicketPrinted ? (
              <div
                className={[CSSClasses.baseBtn, CSSClasses.btnCancel].join(" ")}
                onClick={() => {
                  this.btnCloseTicket_Click();
                }}
              >
                ZATVORI
              </div>
            ) : null}

            {this.state.isSubmitInProgress ||
            this.state.isPrintingTicket ||
            this.state.isTicketPrinted ||
            this.state.isSubmitSuccess ||
            this.state.isPayoutActionsPaused ? null : (
              <div
                className={[
                  CSSClasses.buttons,
                  isExistingTicket ? "" : CSSClasses.buttonsBotAligned
                ].join(" ")}
              >
                {this.props.currentTicketNumber === 1 ? (
                  //izrada tiketa
                  <Auxx>
                    <div
                      onClick={() => {
                        this.btnCloseTicket_Click();
                      }}
                      className={[
                        CSSClasses.baseBtn,
                        CSSClasses.btnCancel
                      ].join(" ")}
                    >
                      ODUSTANI
                    </div>

                    {this.state.shouldConfirmBet ? (
                      <Auxx>
                        <div
                          className={[
                            CSSClasses.baseBtn,
                            CSSClasses.btnHalfSize,
                            CSSClasses.btnSuccess
                          ].join(" ")}
                          onClick={() => {
                            this.setState({
                              shouldConfirmBet: false,
                              isSubmitInProgress: true
                            });
                            this.submitTicket();
                          }}
                        >
                          DA
                        </div>
                        <div
                          className={[
                            CSSClasses.baseBtn,
                            CSSClasses.btnHalfSize,
                            CSSClasses.btnDanger,
                            CSSClasses.spacedLeft
                          ].join(" ")}
                          onClick={() => {
                            this.setState({
                              shouldConfirmBet: false
                            });
                          }}
                        >
                          NE
                        </div>
                      </Auxx>
                    ) : (
                      <Auxx>
                        <div
                          className={CSSClasses.baseBtn}
                          onClick={() => {
                            this.btnSubmitTicket_Click();
                          }}
                        >
                          {this.state.isSubmitError
                            ? "POKUŠAJ PONOVNO"
                            : "POTVRDI I ISPIŠI"}
                        </div>
                      </Auxx>
                    )}
                  </Auxx>
                ) : null}

                {this.props.ticketData.generalInfo &&
                this.props.ticketData.generalInfo.TicketStatusID === 7 ? (
                  //dobitni
                  <Auxx>
                    {this.state.isInTransferToSaldo ||
                    this.state.isInTransferToWWin ? null : (
                      <div
                        className={[CSSClasses.baseBtn].join(" ")}
                        onClick={() => {
                          this.btnPayoutTicket_Click();
                        }}
                      >
                        {this.state.isInPayout
                          ? this.state.isPayoutActionsPaused ||
                            this.state.isPayoutCompleted
                            ? ""
                            : "POTVRDI"
                          : "ISPLATA LISTIĆA"}
                      </div>
                    )}

                    {this.state.isInPayout ||
                    this.state.isInTransferToWWin ? null : (
                      <div
                        className={[CSSClasses.baseBtn].join(" ")}
                        onClick={() => {
                          this.btnTransferToSaldo_Click();
                        }}
                      >
                        {this.state.isInTransferToSaldo
                          ? this.state.isTransferToSaldoCompleted
                            ? ""
                            : "POTVRDI"
                          : "PREBACI NA SALDO"}
                      </div>
                    )}

                    {this.state.isInPayout ||
                    this.state.isInTransferToSaldo ? null : (
                      <div
                        className={[CSSClasses.baseBtn].join(" ")}
                        onClick={() => {
                          this.btnTransferToWWin_Click();
                        }}
                      >
                        {this.state.isInTransferToWWin
                          ? "POTVRDI"
                          : "PREBACI NA WWIN.COM"}
                      </div>
                    )}

                    <div
                      className={[
                        CSSClasses.baseBtn,
                        CSSClasses.btnCancel
                      ].join(" ")}
                      onClick={() => {
                        this.btnCloseTicket_Click();
                      }}
                    >
                      {(this.state.isInPayout &&
                        !this.state.isPayoutCompleted) ||
                      (this.state.isInTransferToSaldo &&
                        !this.state.isTransferToSaldoCompleted) ||
                      this.state.isInTransferToWWin
                        ? this.state.isPayoutActionsPaused
                          ? ""
                          : "ODUSTANI"
                        : "ZATVORI"}
                    </div>
                  </Auxx>
                ) : null}

                {this.props.ticketData.generalInfo &&
                this.props.ticketData.generalInfo.TicketStatusID === 8 ? (
                  //gubitni
                  <Auxx>
                    <div className={[CSSClasses.baseBtn].join(" ")}>
                      PONOVI PREOSTALE PAROVE
                    </div>
                    <div
                      className={[
                        CSSClasses.baseBtn,
                        CSSClasses.btnCancel
                      ].join(" ")}
                      onClick={() => {
                        this.btnCloseTicket_Click();
                      }}
                    >
                      ZATVORI
                    </div>
                  </Auxx>
                ) : null}

                {this.props.ticketData.generalInfo &&
                this.props.currentTicketNumber > 1 &&
                (this.props.ticketData.generalInfo.TicketStatusID === 1 ||
                  this.props.ticketData.generalInfo.TicketStatusID === 4) ? (
                  //cekajuci
                  <Auxx>
                    <div className={[CSSClasses.baseBtn].join(" ")}>
                      PRIJEVREMENA ISPLATA -{" "}
                      {(
                        this.props.ticketData.generalInfo.WinAmount * 0.8
                      ).toFixed(2)}
                      {this.props.machineInfo.CurrencyCode}
                    </div>
                    <div
                      className={[
                        CSSClasses.baseBtn,
                        CSSClasses.btnCancel
                      ].join(" ")}
                      onClick={() => {
                        this.btnCloseTicket_Click();
                      }}
                    >
                      ZATVORI
                    </div>
                  </Auxx>
                ) : null}
              </div>
            )}
          </div>

          <div className={CSSClasses.clearFix} />

          {this.state.showsRegularKeyboard ? (
            <RegularKeyboard
              closeHandler={() => {
                this.onCloseRegularKeyboard();
              }}
              keyDownHandler={(keyData, isShifted) => {
                this.regularKeyboard_KeyDown(keyData, isShifted);
              }}
              position={KEYBOARD_POSITION_FOR_USERNAME_PASSWORD}
            />
          ) : null}
          {this.state.showsNumbericKeyboard ? (
            <NumericKeyboard
              closeHandler={() => {
                this.onCloseNumericKeyboard();
              }}
              keyDownHandler={(value, isQuickPick) => {
                this.numericKeyboard_KeyDown(value, isQuickPick);
              }}
            />
          ) : null}
        </div>
      </div>
    );
  }

  modalPopupBtnOk_Callback = () => {
    this.setState({ infoMessage: null });
  };

  onCloseNumericKeyboard = () => {
    this.setState({ showsNumbericKeyboard: false });
  };

  onCloseRegularKeyboard = () => {
    this.setState({ showsRegularKeyboard: false });
  };

  regularKeyboard_KeyDown = (keyData, isShifted) => {
    // console.log("KEY DATA ", keyData);
    // console.log("SHIFTED ", isShifted);

    // let oldVal = "";

    // if (keyData.value === "shift") {
    //   return;
    // }

    // if (this.state.currentTextboxID === this.K_TEXTBOX_USERNAME) {
    //   //update username

    //   oldVal = this.state.txtUsernameValue + "";

    //   if (keyData.value === "bksp") {
    //     //rezi ako je duzi od 0
    //     if (oldVal.length > 0) {
    //       this.setState({
    //         txtUsernameValue: oldVal.slice(0, -1)
    //       });
    //     }
    //     return;
    //   }

    //   this.setState({
    //     txtUsernameValue:
    //       oldVal + (isShifted ? keyData.labelShifted : keyData.label)
    //   });
    // } else if (this.state.currentTextboxID === this.K_TEXTBOX_PASSWORD) {
    //   //update password
    //   oldVal = this.state.txtPasswordCharValue + "";

    //   if (keyData.value === "bksp") {
    //     //rezi ako je duzi od 0
    //     if (oldVal.length > 0) {
    //       this.setState({
    //         txtPasswordCharValue: oldVal.slice(0, -1)
    //       });
    //     }
    //     return;
    //   }

    //   if (oldVal.length > 0) {
    //     return;
    //   }

    //   this.setState({
    //     txtPasswordCharValue:
    //       oldVal + (isShifted ? keyData.labelShifted : keyData.label)
    //   });
    // }

    console.log("KEY DATA ", keyData);
    console.log("SHIFTED ", isShifted);

    let oldVal = "";

    if (keyData.value === "shift") {
      return;
    }

    switch (this.state.currentTextboxID) {
      case this.K_TEXTBOX_USERNAME:
        oldVal = this.state.txtUsernameValue + "";
        break;
      case this.K_TEXTBOX_PASSWORD:
        oldVal = this.state.txtPasswordCharValue + "";
        break;
      default:
        break;
    }

    if (keyData.value === "bksp") {
      //rezi ako je duzi od 0
      if (oldVal.length > 0) {
        oldVal = oldVal.slice(0, -1);
      }
    } else {
      oldVal = oldVal + (isShifted ? keyData.labelShifted : keyData.label);
    }

    //i vrati u state
    switch (this.state.currentTextboxID) {
      case this.K_TEXTBOX_USERNAME:
        this.setState({ txtUsernameValue: oldVal });
        break;
      case this.K_TEXTBOX_PASSWORD:
        this.setState({ txtPasswordCharValue: oldVal });
        break;
      default:
        break;
    }
  };

  numericKeyboard_KeyDown = (value, isQuickPick) => {
    console.log("VALUE ", value);

    if (value === -1) {
      //decimala, ne hendlamo to
      return;
    }

    if (value === -2) {
      //delete
      this.setState({ txtAmountPayoutValue: 0 });
      return;
    }

    //popuni value
    var val = this.state.txtAmountPayoutValue * 10 + value;
    this.setState({ txtAmountPayoutValue: parseInt(val, 10) });
  };

  txtNumeric_Enter = id => {
    //daj zvukic
    if (this.beepMedium) {
      //daj zvukic
      this.beepMedium.play();
    }

    console.log(id);
    this.setState({ showsNumbericKeyboard: true, currentTextboxID: id });
  };

  txtRegular_Enter = id => {
    //daj zvukic
    if (this.beepMedium) {
      //daj zvukic
      this.beepMedium.play();
    }

    console.log(id);
    this.setState({ showsRegularKeyboard: true, currentTextboxID: id });
  };

  btnCloseTicket_Click = () => {
    //daj zvukic
    if (this.beepMedium) {
      //daj zvukic
      this.beepMedium.play();
    }

    console.log("btnCloseTicket_Click");

    if (this.state.isPayoutActionsPaused) {
      return;
    }

    if (this.state.isInPayout && !this.state.isPayoutCompleted) {
      //gasi payout
      this.setState({ isInPayout: false });
    } else if (
      this.state.isInTransferToSaldo &&
      !this.state.isTransferToSaldoCompleted
    ) {
      //gasi transfer
      this.setState({ isInTransferToSaldo: false });
    } else if (this.state.isInTransferToWWin) {
      //gasi transfer
      this.setState({ isInTransferToWWin: false });
    } else {
      //resetiraj state
      this.closeTheTicket();
    }

    //gasi sve tipkovnice sigurno
    this.setState({ showsNumbericKeyboard: false });
    this.setState({ showsRegularKeyboard: false });
  };

  closeTheTicket = () => {
    //daj zvukic
    if (this.beepMedium) {
      //daj zvukic
      this.beepMedium.play();
    }

    console.log("Closing the ticket...");

    this.resetState();

    //gasi tiket
    this.props.setTicketNumberForDetails(-1);
  };

  resetState() {
    this.setState({
      isSubmitInProgress: false,
      isSubmitSuccess: false,
      isSubmitError: false,
      shouldConfirmBet: false,
      didConfirmBet: false,
      isPrintingTicket: false,
      isTicketPrinted: false,
      newTicketInfo: null,
      ticketStatusID: 0, //0 uplata 1 prihvacen 7 dobitni 8 gubitni 4 autoriziran(cekajuci)
      isInPayout: false,
      isInTransferToSaldo: false,
      isInTransferToWWin: false,
      showsRegularKeyboard: false,
      showsNumbericKeyboard: false,
      txtUsernameValue: "",
      txtPasswordCharValue: "",
      txtAmountPayoutValue: 0,
      currentTextboxID: 0,
      isTransferToSaldoCompleted: false,
      isPayoutActionsPaused: false,
      isPayoutInProgress: false,
      isPayoutCompleted: false,
      totalDispendedAmount: 0,
      infoMessage: null,
      authorizationStatus: 0, //0 nista 1 zaprimljen 2 odbijen 3 modificiran i vracen 4 autoriziran
      lastSentTicketPayload: {}
    });
  }

  btnPayoutTicket_Click = () => {
    //daj zvukic
    if (this.beepMedium) {
      //daj zvukic
      this.beepMedium.play();
    }

    console.log("btnPayoutTicket_Click");

    if (this.state.isPayoutActionsPaused || this.state.isPayoutCompleted) {
      return;
    }

    var msg = "";

    if (!this.state.isInPayout) {
      //zapocni payout,
      this.setState({ isInPayout: true });
    } else {
      //u payoutu je, zavrsi payout

      //validacija iznosa da je dividable s 10
      if (this.state.txtAmountPayoutValue === 0) {
        // alert(
        //
        // );

        msg = (
          <p>
            Unesite željeni iznos isplate! Iznos mora biti okrugao, odnosno
            završavati s nulom.
            <br />
            <br />
            Primjer ispravnih isplata:
            <br />
            10 BAM
            <br />
            20 BAM
            <br />
            70 BAM
            <br />
            120 BAM
          </p>
        );

        this.setState({ infoMessage: msg });

        return;
      }

      //provjeri iznos amount
      if (
        this.state.txtAmountPayoutValue >
        this.props.ticketData.generalInfo.WinAmount
      ) {
        //alert("Iznos ne može biti veći od iznosa dobitka na listiću!");

        msg = (
          <p>
            Iznos ne može biti veći od iznosa dobitka na listiću!
            <br />
            <br />
            Iznos na listiću: &nbsp;
            {this.props.ticketData.generalInfo.WinAmount.toFixed(2)} BAM
          </p>
        );

        this.setState({ infoMessage: msg });

        return;
      }

      //validacija iznosa da je dividable s 10
      if (this.state.txtAmountPayoutValue % 10 !== 0) {
        // alert(
        //   "Iznos mora biti okrugao (završavati s nulom, npr. 20, 50, 170)!"
        // );

        msg = (
          <p>
            Iznos mora biti okrugao, odnosno završavati s nulom!
            <br />
            <br />
            Primjer ispravnih isplata:
            <br />
            10 BAM
            <br />
            20 BAM
            <br />
            70 BAM
            <br />
            120 BAM
          </p>
        );

        this.setState({ infoMessage: msg });

        return;
      }

      //gasi tipkovnicu
      this.setState({ showsNumbericKeyboard: false });

      //sve ok, zapocni isplatu9
      //alert("isplacujem " + this.state.txtAmountPayoutValue);

      //this.setState({ isPayoutInProgress: true });

      //rokaj
      window.cefCustomObject.checkForPossiblePayout(
        this.state.txtAmountPayoutValue
      );
    }
  };

  btnTransferToSaldo_Click = () => {
    //daj zvukic
    if (this.beepMedium) {
      //daj zvukic
      this.beepMedium.play();
    }

    console.log("btnTransferToSaldo_Click");

    if (this.state.isTransferToSaldoCompleted) {
      return; //gotovo
    }

    if (!this.state.isInTransferToSaldo) {
      //ubaci ga tamo
      this.setState({ isInTransferToSaldo: true });
    } else {
      //u transferu je, napravi transfer
      this.props.addToBalance(
        this.props.ticketData.generalInfo.WinAmount * 100
      );
      this.setState({ isTransferToSaldoCompleted: true });
    }
  };

  btnTransferToWWin_Click = () => {
    //daj zvukic
    if (this.beepMedium) {
      //daj zvukic
      this.beepMedium.play();
    }

    console.log("btnTransferToWWin_Click");
    if (!this.state.isInTransferToWWin) {
      //zapocni payout,
      this.setState({ isInTransferToWWin: true });
    } else {
      //u payoutu je, zavrsi payout
      this.setState({ isInTransferToWWin: true });
    }
  };

  getFormattedTicketNumber = ticketNo => {
    ticketNo = ticketNo.toString();
    //console.log(ticketNo);
    //console.log(ticketNo.length);
    let tmpVal = "";

    for (let i = 0; i < ticketNo.length; i++) {
      tmpVal += ticketNo.charAt(i);

      //console.log(ticketNo.charAt(i));
      if (i > 0 && (i + 1) % 3 === 0) {
        //daj razmak
        tmpVal += " ";
      }
    }

    //console.log(tmpVal);

    return tmpVal;
  };

  getExistingTicketPairsMarkup = isSystemTicket => {
    let counter = 0;

    let tmpDate = new Date();

    //sortiraj parove
    var pairs = this.props.ticketData.pairs;

    //obradi ih svih redom i postavi im sortindex
    if (!isSystemTicket) {
      //normalan ticket
      for (var i = 0; i < pairs.length; i++) {
        var pair = pairs[i];

        if (pair.LiveCurrentTime === null) {
          pair.CurrentTime = "";
        }

        if (pair.LiveCurrentTime.indexOf("'") !== -1) {
          //minuta neka je, rezi i parsaj
          pair.SortIndex = parseInt(pair.LiveCurrentTime.replace("'", ""), 10);
        } else if (pair.LiveCurrentTime === "HT") {
          pair.SortIndex = 45;
        } else if (pair.LiveCurrentTime === "Pause") {
          pair.SortIndex = 0; //na kraj
        } else if (pair.LiveCurrentTime.toUpperCase() === "OOT") {
          pair.SortIndex = 120; //overtime, 120+
        } else if (pair.LiveCurrentTime.indexOf(":") !== -1) {
          pair.SortIndex = parseInt(pair.LiveCurrentTime.replace(":", ""), 10);
        } else {
          pair.SortIndex = 0; //bacaj na kraj jebiga kad ne znas sto je
        }
      }

      pairs.sort((a, b) => {
        return a.SortIndex === b.SortIndex
          ? a.MatchStart > b.MatchStart
            ? 1
            : -1
          : b.SortIndex - a.SortIndex;
      });
    } else {
      //sistemski ticket
      //sortni prvo po fixevima
      //nakon toga po legendi desc
      pairs.sort((a, b) => {
        return a.IsFix === b.IsFix
          ? a.SystemLegend - b.SystemLegend
          : a.IsFix
          ? -1
          : 1;
      });
    }

    console.log("PAREKI SU ", pairs);

    return (
      <div className={CSSClasses.pairContainer}>
        {pairs.map(pair => {
          counter++;

          let needsClearfix = counter % 2 === 0;

          let indicator =
            pair.StatusID === 2
              ? CSSClasses.winningPair
              : pair.StatusID === 1
              ? CSSClasses.pendingPair
              : CSSClasses.losingPair;

          return (
            <Auxx key={pair.IDSportTicketItem}>
              <div className={[CSSClasses.pairBox, indicator].join(" ")}>
                <div className={CSSClasses.tournamentName}>
                  {pair.TournamentName}

                  {/* <p className={CSSClasses.startTimeLabel}>
                    {pair.IsLive
                      ? "LIVE"
                      : moment(pair.MatchStart)
                          .add(-tmpDate.getTimezoneOffset(), "m")
                          .format("ddd, HH:mm")
                          .replace(".", "")}
                  </p> */}
                </div>

                <div className={CSSClasses.betInfoGroup}>
                  <div className={[""].join(" ")}>
                    {pair.IsLive ? (
                      <span className={CSSClasses.lblLive}>live</span>
                    ) : (
                      moment(pair.MatchStart)
                        .add(-tmpDate.getTimezoneOffset(), "m")
                        .format("ddd, HH:mm")
                        .replace(".", "")
                    )}
                    {isSystemTicket ? (
                      pair.IsFix ? (
                        <span className={CSSClasses.lblSystemFix}>FIX</span>
                      ) : (
                        <span className={CSSClasses.lblSystemLegend}>
                          {pair.SystemLegend}
                        </span>
                      )
                    ) : null}
                  </div>
                </div>

                <div className={[CSSClasses.pairInfoBox].join(" ")}>
                  <div className={CSSClasses.pairName}>{pair.MatchName}</div>
                  <div className={CSSClasses.betName}>{pair.BetName}</div>
                  <div className={CSSClasses.pick}>Tip: {pair.PickName}</div>
                </div>

                <div className={[CSSClasses.oddBox].join(" ")}>
                  {pair.Odds.toFixed(2)}
                </div>

                <div className={CSSClasses.resultBox}>-:-</div>

                {needsClearfix || true ? (
                  <div className={CSSClasses.clearFix} />
                ) : null}
              </div>

              {needsClearfix ? (
                <div className={CSSClasses.separatorForBoxes}>&nbsp;</div>
              ) : null}
            </Auxx>
          );
        })}

        <div className={CSSClasses.clearFix} />
      </div>
    );
  };

  getCreatingTicketPairsMarkup = () => {
    let counter = 0;

    return (
      <div className={CSSClasses.pairContainer}>
        {this.props.ticketPairInfo.map(pair => {
          counter++;

          let needsClearfix = counter % 2 === 0;

          let indicator = "";

          let oddsAnim = "";

          if (pair.direction > 0) {
            oddsAnim = CSSClasses.increasedOdds;
          } else if (pair.direction < 0) {
            oddsAnim = CSSClasses.decreasedOdds;
          }

          if (!pair.checked) {
            return null;
          }

          return (
            <Auxx key={pair.matchID}>
              <div
                className={[
                  CSSClasses.pairBox,
                  indicator,
                  pair.checked ? "" : CSSClasses.inactiveBox,
                  pair.isEnabled ? "" : CSSClasses.pausedBox
                ].join(" ")}
              >
                <div className={CSSClasses.tournamentName}>
                  {pair.tournamentName}
                </div>

                <div className={CSSClasses.betInfoGroup}>
                  <div className={[""].join(" ")}>
                    {pair.isLive ? (
                      <span className={CSSClasses.lblLive}>live</span>
                    ) : (
                      moment(pair.matchStart)
                        .format("ddd, HH:mm")
                        .replace(".", "")
                    )}
                    {this.props.currentTicketTypeID === 3 ? (
                      pair.isFix ? (
                        <span className={CSSClasses.lblSystemFix}>FIX</span>
                      ) : (
                        <span className={CSSClasses.lblSystemLegend}>
                          {pair.systemLegend}
                        </span>
                      )
                    ) : null}
                  </div>

                  {pair.isEnabled ? null : (
                    <div className={[""]}>
                      <span
                        className={[
                          SiteIcons.site_icon_danger_outline,
                          CSSClasses.inactivePairIcon,
                          CSSClasses.orangeColor
                        ].join(" ")}
                      />
                    </div>
                  )}

                  {pair.isShown ? null : (
                    <div className={[""]}>
                      <span
                        className={[
                          SiteIcons.site_icon_danger,
                          CSSClasses.inactivePairIcon
                        ].join(" ")}
                      />
                    </div>
                  )}
                </div>

                <div
                  className={[
                    CSSClasses.pairInfoBox,
                    CSSClasses.pairInfoBoxForBuildTicket
                  ].join(" ")}
                >
                  <div className={CSSClasses.pairName}>{pair.matchName}</div>
                  <div className={CSSClasses.betName}>{pair.betName}</div>
                  <div className={CSSClasses.pick}>
                    PICK: {pair.pick}
                    {pair.isEnabled ? null : (
                      <span
                        className={[
                          CSSClasses.inactivePairLegend,
                          CSSClasses.orangeColor
                        ].join(" ")}
                      >
                        Trenutno neaktivno!
                      </span>
                    )}
                    {pair.isShown ? null : (
                      <span
                        className={[CSSClasses.inactivePairLegend].join(" ")}
                      >
                        Više nije u ponudi!
                      </span>
                    )}
                  </div>
                </div>

                <div
                  className={[
                    CSSClasses.oddBox,
                    CSSClasses.forBuildTicket,
                    oddsAnim
                  ].join(" ")}
                >
                  {GetConvertedOdds(this.props.currentOddFormat, pair.odds)}
                </div>

                {needsClearfix || true ? (
                  <div className={CSSClasses.clearFix} />
                ) : null}
              </div>

              {needsClearfix ? (
                <div className={CSSClasses.separatorForBoxes}>&nbsp;</div>
              ) : null}
            </Auxx>
          );
        })}

        <div className={CSSClasses.clearFix} />
      </div>
    );
  };

  // btn handlers
  btnSubmitTicket_Click = () => {
    //daj zvukic
    if (this.beepMedium) {
      //daj zvukic
      this.beepMedium.play();
    }

    //resetiraj state za slucaj da se ponavljalo ista
    this.resetState();

    //ako ima neaktivnih parova reci da mora potvrdit zbog neaktivnih parova
    //ako ima ikoji koji ima isEnabled false onad je neaktivan
    let hasInactivePairs =
      this.props.ticketPairInfo.filter(x => !x.isEnabled).length > 0;

    console.log(this.props.ticketPairInfo);

    //todo: logic...
    if (hasInactivePairs) {
      this.setState({
        shouldConfirmBet: true
      });
    } else {
      //submitaj tiket
      this.setState({
        shouldConfirmBet: false,
        isSubmitInProgress: true
      });
      this.submitTicket();
    }

    //return;

    // this.setState({
    //   isSubmitInProgress: true,
    //   isSubmitError: false,
    //   shouldConfirmBet: true,
    //   isSubmitSuccess: false
    // });

    //salji tiket u bazu
    //this.submitTicket();
  };

  submitTicket = () => {
    console.log("THIS IS ", this);

    //samo aktivni parovi!
    let activePairs = this.props.ticketPairInfo.filter(x => x.isEnabled);
    var isLiveTicket =
      this.props.ticketPairInfo.filter(x => x.isLive).length > 0;

    console.log("active pairs ", activePairs);

    //podijeli po tiketu
    if (this.props.currentTicketTypeID === 2) {
      //combo
      SubmitComboTicket(
        {
          totalBet: this.getTotalBetForTicket(),
          totalOdds: this.props.totalOdds,
          terminalGuid: this.props.machineInfo.MachineGUID,
          winAmount: Math.round(this.getMaxPayoutForTicket()),
          isPromoUsed: false,
          isLiveTicket: isLiveTicket,
          numberOfPairs: activePairs.length,
          appId: Preferences.APP_ID,
          ticketTypeID: this.props.currentTicketTypeID,
          languageCode: this.props.currentLanguage
        },
        activePairs,
        this.submitTicket_Callback
      );
    } else {
      //system
      SubmitSystemTicket(
        {
          totalBet: this.getTotalBetForTicket(),
          totalOdds: 0,
          terminalGuid: this.props.machineInfo.MachineGUID,
          winAmount: Math.round(this.getMaxPayoutForTicket()),
          isPromoUsed: false,
          isLiveTicket: isLiveTicket,
          numberOfPairs: activePairs.length,
          appId: Preferences.APP_ID,
          ticketTypeID: this.props.currentTicketTypeID,
          languageCode: this.props.currentLanguage
        },
        activePairs,
        this.props.systemCombinations,
        this.submitTicket_Callback
      );
    }

    // setTimeout(() => {
    //   SubmitComboTicket(
    //     {
    //       totalBet: this.props.betAmount,
    //       totalOdds: this.props.totalOdds,
    //       terminalGuid: this.props.machineInfo.MachineGUID,
    //       winAmount: this.props.betAmount * this.props.totalOdds,
    //       isPromoUsed: false,
    //       isLiveTicket: true,
    //       numberOfPairs: 0,
    //       appId: Preferences.APP_ID,
    //       ticketTypeID: this.props.currentTicketTypeID
    //     },
    //     this.props.ticketPairInfo,
    //     this.submitTicket_Callback
    //   );
    // }, 0);
  };

  // service callbacks
  submitTicket_Callback = val => {
    console.log("THIS IS CALLBACK ", val);

    if (val) {
      console.log("RECEIVED RESPONSE FOR TICKETNO: ", val.TicketNumber);

      if (val.ResponseCode !== 200) {
        //todo
        this.setState({
          infoMessage: "Greska prilikom spremanja tiketa. " + val.ResponseCode,
          isSubmitInProgress: false,
          isSubmitError: true
        });
        return;
      }

      //cache u state
      this.setState({
        lastSentTicketPayload: val,
        authorizationStatus: 1 //zaprimljen
      });

      //zovi autorizaciju
      AuthorizeTicket(
        val.IDSportTicket,
        this.authorizeTicket_Callback.bind(this)
      );
    } else {
      this.setState({
        infoMessage: "Nema odgovora od servera prilikom slanja tiketa!",
        isSubmitError: true,
        isSubmitInProgress: false
      });
    }
  };

  authorizeTicket_Callback = val => {
    console.log("THIS IS authorizeTicket_Callback CALLBACK ", val);

    if (!val || val === "?") {
      console.log("NO NO ", val);
      this.setState({
        infoMessage: "Nema odgovora od servera prilikom autorizacije!",
        isSubmitError: true,
        isSubmitInProgress: false
      });
      return;
    }

    var code = parseInt(val, 10);

    if (code === 4) {
      //autoriziran, nastavi dalje
      //samo aktivni parovi!

      //uzmi pare
      UpdateSessionBalance(
        this.props.machineInfo.ActiveUserSessionID,
        Math.floor(this.getTotalBetForTicket() * -1), //*negativno jer oduzima
        this.updateSessionBalance_Callback.bind(this)
      );
    } else {
      //nije autoriziran, nista od svega, prikazat ce se poruka
      this.setState({
        isSubmitError: true,
        isSubmitInProgress: false
      });
    }

    //postavi ga u state
    this.setState({ authorizationStatus: code });
  };

  updateSessionBalance_Callback = val => {
    console.log("THIS IS updateSessionBalance_Callback CALLBACK ", val);

    if (!val || val === "?") {
      console.log("NO NO ", val);
      this.setState({
        infoMessage: "Nema odgovora od servera prilikom azuriranja salda!",
        isSubmitError: true,
        isSubmitInProgress: false
      });
      return;
    }

    var newBalance = parseInt(val, 10);

    if (newBalance > 0) {
      //podesi na saldo
      //doslo u centima, centi i pasu
      this.props.onUpdateBalance(newBalance);

      //i ispisi tiket
      // let activePairs = this.props.ticketPairInfo.filter(x => x.isEnabled);

      // let json = JSON.stringify({
      //   ticketInfo: {
      //     totalBet: this.getTotalBetForTicket(),
      //     totalOdds: this.props.totalOdds,
      //     terminalGuid: this.props.machineInfo.MachineGUID,
      //     winAmount: this.getMaxPayoutForTicket(),
      //     isPromoUsed: false,
      //     isLiveTicket: true,
      //     numberOfPairs: 0,
      //     appId: Preferences.APP_ID,
      //     ticketNumber: this.state.lastSentTicketPayload.TicketNumber,
      //     timestamp: this.state.lastSentTicketPayload.TimestampAccepted,
      //     ticketCode: this.state.lastSentTicketPayload.TicketCode,
      //     languageCode: this.props.currentLanguage,
      //     ticketTypeID: this.props.currentTicketTypeID
      //   },
      //   ticketPairs: activePairs,
      //   systems: this.props.systemCombinations
      // });

      var today = new Date();
      var localOffset = today.getTimezoneOffset();

      let json = JSON.stringify({
        ticketNumber: this.state.lastSentTicketPayload.TicketNumber,
        ticketCode: this.state.lastSentTicketPayload.TicketCode,
        localTimeOffset: localOffset
      });

      window.cefCustomObject.printTicket(json);

      this.setState({
        isSubmitSuccess: true,
        isSubmitInProgress: false,
        newTicketInfo: this.state.lastSentTicketPayload
      });

      //stavi nakon sekunde da ispisuje tiket
      setTimeout(() => {
        this.setState({
          isPrintingTicket: true
        });
      }, 1000);
    } else {
      //greska!
      this.setState({
        infoMessage: "Greška prilikom azuriranja salda! " + newBalance,
        isSubmitError: true,
        isSubmitInProgress: false
      });
    }
  };
}

const mapStateToProps = state => {
  return {
    currentTicketNumber: state.rrNavigation.currentTicketNumber,
    ticketPairInfo: state.rrTicket.ticketPairInfo,
    currentOddFormat: state.rrAppState.oddFormatID,
    betAmount: state.rrTicket.betAmount,
    totalOdds: state.rrTicket.totalOdds,
    currentLanguage: state.rrAppState.currentLanguage,
    printerStatusList: state.rrAppState.printerStatuses,
    currentTicketTypeID: state.rrTicket.ticketTypeID,
    systemCombinations: state.rrTicket.systemCombinations,
    machineInfo: state.rrAppState.machineInfo
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setTicketNumberForDetails: ticketNumber =>
      dispatch(StoreActions.SetTicketNumberForDetails(ticketNumber)),
    addToBalance: amount => dispatch(StoreActions.AddToBalance(amount, true)),
    onUpdateBalance: amount =>
      dispatch(StoreActions.UpdateBalance(amount, true))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TicketPreview);



// WEBPACK FOOTER //
// ./src/Components/TicketPreview/TicketPreview.js